import { render, staticRenderFns } from "./QuadroCreditoPresumido.vue?vue&type=template&id=6acc2884&scoped=true&"
import script from "./QuadroCreditoPresumido.vue?vue&type=script&lang=js&"
export * from "./QuadroCreditoPresumido.vue?vue&type=script&lang=js&"
import style0 from "./QuadroCreditoPresumido.vue?vue&type=style&index=0&id=6acc2884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acc2884",
  null
  
)

export default component.exports